import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { carSearch } from '../../../../../store/slices/car';
import { setCarTripSearchInputs } from '../../../../../store/slices/tripSearch';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';
import carSearchInput from '../../../../../helpers/selectors/carSearchInput';

const CarTypeFilter = ({ tripId, selectedTab, bgClassName }) => {
  const isTripSearch = !tripId;
  const {
    searchInputs, responseFilters,
  } = useSelector(carSearchInput(tripId, selectedTab, isTripSearch));
  const dispatch = useDispatch();

  const handleChange = useCallback((newValue) => {
    if (isTripSearch) {
      dispatch(setCarTripSearchInputs({
        carTypes: newValue,
      }));
    } else {
      dispatch(carSearch({
        tripId,
        selectedTab,
        searchObj: {
          ...searchInputs,
          page: 1,
          carTypes: newValue,
        },
      }));
    }
  }, [isTripSearch, dispatch, tripId, selectedTab, searchInputs]);

  return (
    <>
      {responseFilters && responseFilters.carTypesResults && responseFilters.carTypesResults.length
        ? (
          <CheckboxSelectFilter
            options={responseFilters.carTypesResults || []}
            values={searchInputs.carTypes}
            onChange={handleChange}
            label="Car type"
            variant={!isTripSearch ? 'outline' : undefined}
            bgClassName={!isTripSearch ? '' : bgClassName}
          />
        ) : <></>}
    </>
  );
};

CarTypeFilter.propTypes = {
  tripId: PropTypes.string,
  bgClassName: PropTypes.string,
  selectedTab: PropTypes.number,
};

CarTypeFilter.defaultProps = {
  tripId: undefined,
  bgClassName: undefined,
  selectedTab: 0,
};
export default memo(CarTypeFilter);
